/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The kind of operational issue. The first values mirror the
 * carrier-actionable operations task types; `pending_customs_clearance`
 * is a synthetic type for shipments held at the border.
 *
 * @export
 */
export const CarrierIssueType = {
  BookPickup: "book_pickup",
  MissedPickup: "missed_pickup",
  ExpectedDeliveryIsInThePast: "expected_delivery_is_in_the_past",
  TrackingNotUpdated: "tracking_not_updated",
  MissedDelivery: "missed_delivery",
  MissingFreight: "missing_freight",
  PendingCustomsClearance: "pending_customs_clearance",
} as const;
export type CarrierIssueType =
  (typeof CarrierIssueType)[keyof typeof CarrierIssueType];

export function instanceOfCarrierIssueType(value: any): boolean {
  for (const key in CarrierIssueType) {
    if (Object.prototype.hasOwnProperty.call(CarrierIssueType, key)) {
      if (CarrierIssueType[key as keyof typeof CarrierIssueType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierIssueTypeFromJSON(json: any): CarrierIssueType {
  return CarrierIssueTypeFromJSONTyped(json, false);
}

export function CarrierIssueTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierIssueType {
  return json as CarrierIssueType;
}

export function CarrierIssueTypeToJSON(value?: CarrierIssueType | null): any {
  return value as any;
}

export function CarrierIssueTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierIssueType {
  return value as CarrierIssueType;
}
